import { Card, Box } from '@shopify/polaris';
import ApplicationSettings from '../ApplicationSettings/ApplicationSettings';

const SettingsTab = () => {
    return (
        <Card title="Application Settings">
            <Box paddingBlockEnd="600">
                <ApplicationSettings />
            </Box>
        </Card>
    );
};

export default SettingsTab;
